export const ERROR_CODE_MAP = {
  STONE_ANTIFRAUD_BLOCKED: {
    message: "Falha ao processar pagamento.  Erro 1001, entre em contato com nosso time de atendimento.",
    type: "error",
    shouldShowFieldErrors: false, 
  }
};

export const extractErrorCode = (errorResponse) => {
  if (!errorResponse || typeof errorResponse !== "object") {
    return null;
  }

  return errorResponse.code || null;
};

export const getErrorMessage = (errorResponse) => {
  if (!errorResponse || typeof errorResponse !== "object") {
    return {
      message: "Falha ao processar pagamento. Reveja os dados do cartão e tente novamente",
      type: "error",
      shouldShowFieldErrors: true,
    };
  }

  const errorCode = extractErrorCode(errorResponse);

  if (errorCode && ERROR_CODE_MAP[errorCode]) {
    return ERROR_CODE_MAP[errorCode];
  }

  return {
    message: "Falha ao processar pagamento. Reveja os dados do cartão e tente novamente",
    type: "error",
    shouldShowFieldErrors: true,
  };
};

export const parseError = (error) => {
  const errorResponse = error?.response?.data || null;
  const errorCode = extractErrorCode(errorResponse);
  const errorInfo = getErrorMessage(errorResponse);

  return {
    code: errorCode,
    messages: errorResponse?.messages || [],
    errorInfo,
    errorResponse,
  };
};

